import React, { useState, FormEvent, ReactNode } from "react";
import styles from "./PasswordGate.module.css";
import NavBar from "./NavBar";

const PASSWORD = process.env.REACT_APP_CASE_STUDY_PASSWORD;
const SESSION_KEY = "private-case-study-auth";

type Props = {
  children: ReactNode;
};

const PasswordGate = ({ children }: Props) => {
  const [unlocked, setUnlocked] = useState(
    () => sessionStorage.getItem(SESSION_KEY) === "true"
  );
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (PASSWORD && value === PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, "true");
      setUnlocked(true);
    } else {
      setError(true);
      setValue("");
    }
  };

  if (unlocked) {
    return <>{children}</>;
  }

  return (
    <div className={styles.overlay}>
      <NavBar />
      <form className={styles.form} onSubmit={handleSubmit}>
        <p className={styles.label}>This case study is password protected</p>
        <input
          className={styles.input}
          type="password"
          placeholder="Enter password"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setError(false);
          }}
          autoFocus
        />
        {error && <p className={styles.error}>Incorrect password</p>}
      </form>
    </div>
  );
};

export default PasswordGate;
